export default __webpack_public_path__ + "static/media/Graph-Logo-Nuevo-1.f1f9d360.png";